module.exports = __webpack_public_path__ + "img/ewm.602ba5bd.png";